import * as yup from 'yup';

// Schémas de validation Yup
const headOfficeAddressValidationSchema = yup.object().shape({
    address: yup.string().required('L\'adresse est requise'),
    postalCode: yup
        .string()
        .required('Le code postal est requis')
        .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),
    city: yup.string().required('La ville est requise'),
    registrationOffice: yup.string().required('Le bureau d\'enregistrement est requis')
});

export default headOfficeAddressValidationSchema